import AuthLayout from '@components/Login/AuthLayout';
import CreateAdministratorCard from '@components/Setup/CreateAdministratorCard';

const SetupPage = () => {
  return (
    <AuthLayout>
      <CreateAdministratorCard />
    </AuthLayout>
  );
};

export default SetupPage;
